export const VIEW = 'view';
export const VIEW_PATH = `/${VIEW}`;

export const VIEW_ALL = 'viewAll';
export const VIEW_ALL_PATH = `/${VIEW_ALL}`;


export const HOME_PATH = '/';

export const TEST = 'tests';
export const TEST_PATH = `/${TEST}`;
export const TEST_VIEW_PATH = `/${TEST}/${VIEW}`;
export const TEST_VIEW_ALL_PATH = `/${TEST}/${VIEW_ALL}`;
export const TEST_VIEW_ALL_ITEM_PATH = `/${TEST}/${VIEW_ALL}/id`;
export const TEST_VIEW_ITEM_MINI_PATH = `/${TEST}/${VIEW_ALL}/mini/id`;

export const ARCHIVES = 'archives';
export const ARCHIVES_PATH = `/${ARCHIVES}`;
export const ARCHIVES_VIEW_PATH = `/${ARCHIVES}/${VIEW}`;

export const PARTOGRAM = 'partograms';
export const PARTOGRAM_PATH = `/${PARTOGRAM}`;
export const PARTOGRAM_VIEW_PATH = `/${PARTOGRAM}/${VIEW}`;

export const MCP_CARD = 'mcpcards';
export const MCP_CARD_PATH = `/${MCP_CARD}`;
export const MCP_CARD_VIEW_PATH = `/${MCP_CARD}/${VIEW}`;

export const ADMIN = 'admin';
export const ADMIN_PATH = `/${ADMIN}`;

export const STATS = 'stats';
export const STATS_PATH = `/${STATS}`;

export const LOGIN = 'login';
export const LOGIN_PATH = `/${LOGIN}`;

export const LOGOUT = 'logout';
export const LOGOUT_PATH = `/${LOGOUT}`;

export const INSTRUCTIONS = 'instructions';
export const INSTRUCTIONS_PATH = `/${INSTRUCTIONS}`;

export const RESET_PASSWORD = 'reset-password';
export const RESET_PASSWORD_PATH = `/${RESET_PASSWORD}`;

export const REGISTER = 'register';
export const REGISTER_PATH = `/${REGISTER}`;
export const REGISTER_VERIFY_PATH = `/${REGISTER}/verify`;
export const REGISTER_COMPLETE_PATH = `/${REGISTER}/complete`;
export const REGISTER_INVITE_PATH = `/${REGISTER}/invite`;

export const FORGOT_PASSWORD = 'forgot-password';
export const FORGOT_PASSWORD_PATH = `/${FORGOT_PASSWORD}`;

export const NEW_USER = 'newUser';
export const NEW_USER_PATH = `/${NEW_USER}`;
